function Validator_string(element) {
    this.$element = $(element);
    this.isList = false; // ul lists for radio and checkboxes

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]'
    };

    this.data = {
	    required: 'required',
	    messageFail: 'message-fail',
	    minLength: 'min-length',
	    maxLength: 'max-length',
	    disallowWords: 'disallow-words',
	    rejectedStartString: 'rejected-start-string',
	    characterInvalid: 'character-invalid',
	    characterValid: 'character-valid',
	    allowedStartString: 'allowed-start-string',
	    uniqueDomId: 'unique-dom-id',
      validateOnSubmit: 'validate-on-submit'
    };

    this.triggers = {
	    validate: 'i4:validate',
	    updateView: 'i4:updateView',
	    refresh: 'i4:refresh'
    };

    this.classNames = {
	    failMessage: 'fail-message'
    };

    this.init = function() {

	    // console.log('init - string');

	    this.$formParent = this.$element.parents(this.selectors.formParent);

	    this.dataRequired = this.$element.data(this.data.required);
	    this.dataMessageFail = this.$element.data(this.data.messageFail);

	    this.dataMinLength = this.$element.data(this.data.minLength);
	    this.dataMaxLength = this.$element.data(this.data.maxLength);
	    this.dataDisallowWords = this.$element.data(this.data.disallowWords);
	    this.dataRejectedStartString = this.$element.data(this.data.rejectedStartString);
	    this.dataCharacterInvalid = this.$element.data(this.data.characterInvalid);
	    this.dataCharacterValid = this.$element.data(this.data.characterValid);
	    this.dataAllowedStartString = this.$element.data(this.data.allowedStartString);
	    this.uniqueDomId = this.$element.data(this.data.uniqueDomId);

	    if (this.$element.prop('tagName').toUpperCase() == 'UL') {
		    this.isList = true;
		    this.$inputElements = this.$element.find('input');
		    this.$inputElements.on('click change focus', this.$elementChange.bind(this));
	    } else {
			this.$element.on('keyup blur change', this.$elementChange.bind(this));
	    }

	    this.$formParent.trigger(this.triggers.refresh);

	    this.$element.on(this.triggers.validate, this.validate.bind(this));

		this.validateOnSubmit = this.$formParent.length && this.$formParent.data(this.data.validateOnSubmit);
		this.prepareFailMessage();

		if (!this.validateOnSubmit) {
			this.validate();
		}

    };

    this.$elementChange = function() {
	    this.validate();
	    this.$element.trigger('i4:change');

	    this.$formParent.trigger(this.triggers.updateView);
    };

    this.validate = function() {

	    this.value = this.getValue();
	    this.dataRequired = parseInt(this.$element.attr('data-'+this.data.required));

	    var isValid = i4_Validator.isValidString(this.value, {
		    minLength: this.dataMinLength,
		    maxLength: this.dataMaxLength,
		    disallowWords: this.dataDisallowWords,
		    rejectedStartString: this.dataRejectedStartString,
		    characterInvalid: this.dataCharacterInvalid,
		    characterValid: this.dataCharacterValid,
		    allowedStartString: this.dataAllowedStartString,
		    uniqueDomId: this.uniqueDomId
	    });

	    // console.log('isValid', isValid);

	    this.$element.removeClass('invalid');
		this.$element.removeClass('valid');
		this.$failMessage.hide();

		if (isValid) {
			this.$element.addClass('valid');
		} else if (this.value != '' || this.dataRequired) {
			this.$element.addClass('invalid');

			if (this.validateOnSubmit || this.value != '') {
				this.$failMessage.show();
			} else {
				this.$failMessage.hide();
			}
		}
    };

    this.getValue = function() {
	    var result = '';

	    if (this.isList) {
		    var checkedItem = this.$element.find(':checked');

		    if (checkedItem.length) {
		    	result = checkedItem.val();
		    }
		    // console.log('checked result', result);
	    } else {
	    	result = this.$element.val();
	    }

	    return result;
    };

    this.prepareFailMessage = function() {
	    this.$failMessage = $('<div></div>');

	    if (this.dataMessageFail !== undefined) {
		    this.$failMessage.
		    	addClass(this.classNames.failMessage).
		    	html(this.dataMessageFail).
		    	hide();

		    this.$element.after(this.$failMessage);
	    }
    };

}
